import React from "react";
import BaseComponent from "../BaseComponent.js";
import styled from "styled-components";
import nota from "../Global/nota.guidelines.json";

import Type from "../Global/Typography.js";
import NanoFlex from "./../Global/NanoFlex";
import SocialIcons from "../Nano/SocialIcons.js";

import glanceNav from "./../../images/glanceNav.svg";

const multiple = nota.global.multiple;

const StyledFooter = styled(NanoFlex)`
  width: 100%;
  height: auto;
  footer {
    width: 100%;
    padding: ${multiple + "px"} ${multiple * 2 + "px"}; /*8px 16px*/
    border-top: 1px solid ${nota.color.neutral.NeuFour};
    .footerWrapper {
      .logoWrapper {
        margin-right: ${multiple * 2 + "px"};
        img {
          height: 32px;
        }
      }
      svg {
        path {
          fill: ${nota.color.neutral.NeuOne};
        }
      }
    }
  }
  .mobileShow {
    display: none;
  }

  /* MEDIA QUERIES */
  @media only screen and (max-width: 800px) {
    .mobileShow {
      display: flex;
    }
  }
`;

export class Footer extends BaseComponent {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    super.componentDidMount();
  }

  componentWillUnmount() {
    super.componentWillUnmount();
  }

  render() {
    return (
      <StyledFooter>
        <footer>
          <NanoFlex className="footerWrapper" justifyContent={"space-between"}>
            <NanoFlex justifyContent="flex-start">
              <a className="logoWrapper mobileShow" href="https://www.glance-mediametrie.com/" rel="noopener noreferrer" target="_blank">
                <img src={glanceNav} alt="Glance Logo Navbar" />
              </a>
              <Type.h6>Médiamétrie - Glance - {this.translation.footer.allRightsReserved} @ 2001-2025 E-Nota</Type.h6>
            </NanoFlex>

            <SocialIcons />
          </NanoFlex>
        </footer>
      </StyledFooter>
    );
  }
}

export default Footer;

// --- // Documentation // --- //
/*
import Footer from './Footer.js';

<Footer />
*/
